var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.598,
    height: 45.254,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 17286"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#08c",
    d: "M34.998 45.25h-30a5.008 5.008 0 0 1-5-5v-30a5 5 0 0 1 5-5h23.457a.721.721 0 0 0-.252.547v5.047a.72.72 0 0 0 .721.719h4.109l6.307 4.2a.681.681 0 0 0 .656.072v24.412a5.007 5.007 0 0 1-4.998 5.003ZM20.539 29.111l3.664 2.713a1.255 1.255 0 0 0 .6.18c.373 0 .629-.279.738-.807l2.406-11.371-.008-.012a1.157 1.157 0 0 0-.115-.988.664.664 0 0 0-.529-.248.938.938 0 0 0-.379.084l-14.18 5.469c-.484.2-.754.449-.742.689.01.2.217.375.57.48l3.639 1.135 1.264 4.123c.027.08.049.152.066.217l.012.041c.076.27.105.381.48.381a.94.94 0 0 0 .727-.363l.012-.014 1.773-1.709Z",
    "data-name": "Soustraction 4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 17285"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#08c",
    "data-name": "Groupe 17284"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.518 13.3a6.4 6.4 0 0 0 0-10.941.674.674 0 1 0-.729 1.133l.029.018a5.052 5.052 0 0 1 0 8.64.674.674 0 1 0 .673 1.168l.029-.018Z",
    "data-name": "Trac\\xE9 12131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.266 10.902a3.7 3.7 0 0 0 0-6.147.676.676 0 1 0-.759 1.118 2.357 2.357 0 0 1 0 3.913.674.674 0 1 0 .729 1.134l.026-.018Z",
    "data-name": "Trac\\xE9 12132"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#08c",
    d: "M40.455 1.472v13.7a.719.719 0 0 1-1.117.6l-6.307-4.2h-4.109a.723.723 0 0 1-.721-.729V5.797a.723.723 0 0 1 .721-.721h4.108l6.307-4.2a.694.694 0 0 1 .735-.036.709.709 0 0 1 .383.632Z",
    "data-name": "Trac\\xE9 12133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.734 0a1.48 1.48 0 0 1 1.467 1.474v13.692a1.467 1.467 0 0 1-2.286 1.222l-6.114-4.075h-3.879a1.477 1.477 0 0 1-1.471-1.468V5.797a1.477 1.477 0 0 1 1.469-1.471h3.881L38.917.252A1.438 1.438 0 0 1 39.734 0Zm-.033 15.109V1.53l-6.447 4.3h-4.303v4.987h4.306Z",
    "data-name": "Trac\\xE9 12133 - Contour"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.734.252a1.23 1.23 0 0 1 1.221 1.226v13.689a1.217 1.217 0 0 1-1.9 1.013l-6.18-4.117h-3.953a1.226 1.226 0 0 1-1.221-1.219V5.797a1.226 1.226 0 0 1 1.219-1.221h3.959L39.057.46a1.189 1.189 0 0 1 .677-.208Zm0 15.139a.2.2 0 0 0 .1-.025h.009a.208.208 0 0 0 .113-.187V1.472a.21.21 0 0 0-.113-.191l-.013-.007a.2.2 0 0 0-.206.01l-.008.006-6.434 4.286h-4.26a.223.223 0 0 0-.221.222v5.044a.223.223 0 0 0 .222.221h4.259l6.437 4.289a.2.2 0 0 0 .116.036Z",
    "data-name": "Trac\\xE9 12133 - Contour"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.362 31.865c-.12-.061-1.021-.705-2.001-1.432-.98-.726-1.799-1.32-1.818-1.32-.02 0-.497.442-1.06.983-.856.823-1.058.993-1.237 1.04-.255.07-.524.029-.587-.088-.024-.046-.357-1.103-.74-2.35-.381-1.245-.7-2.27-.707-2.276-.008-.007-.814-.26-1.791-.564a95.489 95.489 0 0 1-1.975-.627c-.586-.223-.548-.655.085-.975.143-.072 3.293-1.3 6.999-2.727l7.182-2.767c.341-.132.494-.166.658-.148.368.04.6.359.6.827 0 .097-.556 2.807-1.236 6.022-.872 4.124-1.27 5.92-1.355 6.094-.201.418-.575.532-1.017.308z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.04936229
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramSound);
export default __webpack_public_path__ + "static/media/telegramSound.6f110bf790146df8b0d56fd7c0e1d766.svg";
export { ForwardRef as ReactComponent };